import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemOption } from '@app/basic/facesheet/facesheet-common';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
})
export class SelectItemComponent implements OnInit {

  constructor() { }

  @Input() label: string = '';
  @Input() options: ItemOption[] = [];
  @Input()
  get currentValue() {
    return this._currentValue || undefined;
  }

  set currentValue(value: string | number | undefined) {
    this._currentValue = value;
  }

  @Input() placeholder: string = '選択して下さい';
  // @Input() form!: FormControl;
  @Input() required: boolean = false;
  // select Width
  @Input() selectStyle: Object = new Object();
  @Input() disabled: boolean = false;
  @Output() onChange: EventEmitter<string | number> = new EventEmitter<string | number>();

  _currentValue: string | number | undefined = undefined;
  ngOnInit(): void {

  }

  onValueChange(value: string | number | undefined) {
    this.currentValue = value;
    console.log(this.currentValue);
    this.onChange.emit(this.currentValue);
  }

}
